import request from "./request"
export const getAllSubject=(v)=>request.get("/goods/subjectGoods/getAllSubject",v)
export const getArticleCategory=(v)=>request.get("/goods/subjectGoods/articleCategory/list",v)
export const getSubjectGoods=(v,x)=>request.get(`/goods/subjectGoods/getGoodsBySecondId/${v}`,{params: x})
export const getGoodsByName=(v)=>request.get(`/goods/subjectGoods/getGoodsByName`,{params: v})
export const getDetails=(v,x)=>request.get(`/goods/goods/get/${v}`,{params: x})
export const getCoupon=(x)=>request.get(`/promotion/coupon`,{params: x})
export const getActivityData=(x,y)=>request.get(`/page/zfb-act-page-config/${x}`,{params: y})
export const highPassingRateList=(x,y)=>request.get(`/setting/setting/highPassingRateList`,{params: y})
//传入token
export const highPassingRateListV2 = ( token) => request.get(`/setting/setting/highPassingRateList/v2`, {  headers: {
    accessToken: token
  }})
//平台协议列表(注意路径是双order段)
export const getAllOrderAgreement=(v)=>request.get("/order/order/getAllOrderAgreement",{params: v})
//经营资质验证码图片(common-api域,完整URL绕过baseURL)
export const getCaptcha=(uuid)=>request.get("https://common-api.mzxx.top/common/common/captcha/QUERY_STORE_COMPANY_DETAILS", { headers: { uuid }})
//经营资质验证码验证
export const postCaptcha=(code, uuid) => request.post("https://common-api.mzxx.top/common/common/captcha/QUERY_STORE_COMPANY_DETAILS", { code }, { headers: { uuid, "Content-Type": "application/x-www-form-urlencoded" }})
//公司资质详情
export const getCompanyDetail=(uuid)=>request.get("/store/store/get/companyDetail/1580439172399886338", { headers: { uuid }})
//评价-最新一条(无评价 result 为 null)
export const getEvaluationLatest=(v)=>request.get(`/member/evaluation/${v}/latest`)
//评价-数量(返回 {all,good,moderate,worse,haveImage})
export const getEvaluationNumber=(v)=>request.get(`/member/evaluation/${v}/evaluationNumber`)
//问大家-最新提问(limit 按文档要求传 1)
export const getQuestionTop=(v)=>request.get(`/goods/question/top/${v}`,{params:{limit:1}})
//问大家-数量(返回裸数字)
export const getQuestionCount=(v)=>request.get(`/goods/question/count/${v}`)
//问大家-最新提问多条(H5复刻uniapp组件用,limit 2;getQuestionTop 是 limit 1 不动)
export const getQuestionTopList=(v)=>request.get(`/goods/question/top/${v}`,{params:{limit:2}})
//公司资质详情(storeId 动态,供 H5 storeMessage 页)
export const getCompanyDetailByStore=(storeId,uuid)=>request.get(`/store/store/get/companyDetail/${storeId}`, { headers: { uuid }})